module.exports = __webpack_public_path__ + "b07d5a94a2bc888c99687775c6d2c62c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/witch-hazel.jpg
 ** module id = 457
 ** module chunks = 0
 **/